import { NavLink } from 'react-router-dom';
import { data } from '../../../../globals/data/global-services';

export default function SectionServices3({ _data }) {
  return (
    <>
      <div className='section-full p-t120 p-b90 site-bg-gray tw-service-gallery-style4-area tyre-mark-bg'>
        <div className='services-gallery-block-outer2'>
          <div className='container'>
            {/* TITLE START*/}
            <div className='section-head center wt-small-separator-outer'>
              <div className='wt-small-separator site-text-primary'>
                <div>{data.services?.title}</div>
              </div>
              <h2 className='wt-title'>{data.services?.subtitle}</h2>
              <p className='section-head-text'>{data.services?.description}</p>
            </div>
            {/* TITLE END*/}
            <div className='section-content'>
              <div className='services-gallery-style4'>
                <div className='owl-carousel services-gallery-four owl-btn-bottom-center '>
                  {data.services?.services.map((_object, index) => (
                    <div key={index} className='item '>
                      <div className='service-box-style4'>
                        <div className='service-content'>
                          <div className='service-content-inner'>
                            <div className='service-content-top'>
                              <h3 className='service-title-large'>
                                <NavLink to='/services/detail'>
                                  {_object.title}
                                </NavLink>
                              </h3>
                            </div>
                            <div className='service-content-bottom'>
                              <span className='service-title-large-number'>
                                {_object.serial}
                              </span>
                              <p>{_object.shortDescription}</p>
                              <NavLink
                                to='/services/detail'
                                className='site-button-2'
                              >
                                View Detail
                              </NavLink>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='tw-hilite-text-wrap'>
          <div className='tw-hilite-text right'>
            <span>Services</span>
          </div>
        </div>
      </div>
    </>
  );
}
